export default __webpack_public_path__ + "static/media/AP Logo - Icon 4.4a36867c.png";